import './styles/status-pill.css';

export default function StatusPill({ tone = 'idle', children, hasDot = true, className }) {
    return (
        <span className={['status-pill', `status-pill--${tone}`, className].filter(Boolean).join(' ')}>
            {hasDot && <span className="status-pill__dot" aria-hidden="true" />}
            {children}
        </span>
    );
}
